import React from "react";
import { Card, CardContent, Typography, Box, Divider } from "@mui/material";
import { dateFromatter } from "../../utils/utils";
import "../../styles/common.css";

interface NoteCardProps {
  date: string;
  sentiment: string;
  summary: string;
  onClick?: () => void;
}

const sentimentColors: Record<string, string> = {
  Positive: "#1EC96B",
  Neutral: "#F7B750",
  Negative: "#FF4D4D"
};

const sentimentLabels: Record<string, string> = {
  Positive: "Positive",
  Neutral: "Neutral",
  Negative: "Detractor",
};

const NoteCard: React.FC<NoteCardProps> = ({ date, sentiment, summary, onClick }) => {
    const displayLabel = sentimentLabels[sentiment] || sentiment;
    return (
    <Card className="p2p-note-card" onClick={onClick}
      sx={{ cursor: "pointer" }}>
        <CardContent >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} >
            <Typography variant="body1" color="#A6A6B2">
            {dateFromatter(date)}
            </Typography>

            <Box display="flex" alignItems="center" gap={1}>
            <Box className="p2p-sentiment-dot"
                sx={{
                bgcolor: sentimentColors[sentiment],
                }}
            />
            <Typography variant="body1" className="p2p-sentiment-label">
                {displayLabel}
            </Typography>
            </Box>
        </Box>

        <Divider sx={{ my: 2, mx: -2 }} />
        <Box className="p2p-summary-box">
          <Typography variant="body1" className="p2p-summary">
            {summary}
          </Typography>
        </Box>
        </CardContent>
    </Card>
    );
};

export default NoteCard;
